// Export all generated types
export * from '../api/generated';

// Custom application types
export interface CustomerInfo {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  specialOccasion?: string;
  dietaryRestrictions?: string[];
  note?: string;
}

export interface ReservationFormData {
  date: Date;
  people: number;
  selectedTimeslot: Timeslot | null;
  customerInfo: CustomerInfo;
}

export interface Timeslot {
  from: string; // ISO date string
  to: string; // ISO date string
  area_name?: string;
  area_uuid?: string;
}

// Reservation constraints
export const RESERVATION_CONSTRAINTS = {
  MIN_PEOPLE: 1,
  MAX_PEOPLE: 20,
  MIN_DATE_OFFSET: 0, // Can book for today
  MAX_DATE_OFFSET: 90, // Can book up to 90 days in advance
} as const;
